<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :maskClosable="false">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="疾病名称" prop="diseaseName" >
        <a-input v-model="form.diseaseName" placeholder="请输入疾病名称" />
      </a-form-model-item>
      <a-form-model-item label="常见病症" prop="isCommon" >
        <a-select v-model="form.isCommon" placeholder="请选择">
          <a-select-option :value="0">否</a-select-option>
          <a-select-option :value="1">是</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-item label="疾病类型" prop="type">
        <a-select v-model="form.type">
          <a-select-option v-for="item in typeList" :value="item.id">{{item.name}}</a-select-option>
        </a-select>
      </a-form-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getDisease, addDisease, updateDisease } from '@/api/disease/disease'
import {listType} from "@/api/disease/type";

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      typeList: [],
      // 表单参数
      form: {
        id: null,

        diseaseName: null,
        type:null,
        isCommon: null,

        createTime: null,

        remark: null,

      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        diseaseName: [
          { required: true, message: '疾病名称不能为空', trigger: 'blur' }
        ],
        type: [
          { required: true, message: '类型不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
    this.getTypeList()
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {

    getTypeList() {
      listType().then(res => {
        this.typeList = res.data
      })
    },

    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.reset()
      this.open = false
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.form = {
        id: null,
        diseaseName: null,
        type:null,
        isCommon: null,
        createTime: null,
        remark: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getDisease({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.formTitle = '修改'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateDisease(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addDisease(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
